import { HtmlId } from '../enum';
import { debugInfo } from './debug';

/**
 * Mount any brix component
 * @param {HtmlId} id - ID of the element.
 * @param {Function} create - the create function of the selected component
 * @param {Object} props - the properties for the component
 * @returns {Object | null} component or null if element with given id is not found
 */
export const mountComponent = <Pattern, Props>(
    id: HtmlId,
    create: (containerEl: HTMLElement, props: Props) => Pattern,
    props: Props
) => {
    const containerEl = document.getElementById(id);

    if (!containerEl) {
        debugInfo('Cant find element with id: ', id);

        return null;
    }

    try {
        return create(containerEl, props);
    } catch (error) {
        debugInfo(`Cant mount component with id: "${id}", mount function: "${create.name}"\n`, error);

        return null;
    }
};
